import React from 'react';
import T from 'prop-types';
import { Tag } from 'antd';
import capitalize from 'lodash.capitalize';

const UserPlanTag = ({ planName }) => {
  if (!planName) {
    return null;
  }

  return <Tag color="red">{capitalize(planName)}</Tag>;
};

UserPlanTag.propTypes = {
  planName: T.string.isRequired,
};

export default UserPlanTag;
